interface CustomCheckboxProps {
  label: string;
  value: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  testId?: string;
}

export function CustomCheckbox({ label, checked, onChange, testId }: CustomCheckboxProps) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      data-testid={testId}
      className={`w-full flex items-center gap-4 px-4 py-4 rounded-[6px] border bg-white hover:border-gray-300 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2D55FB] focus-visible:ring-offset-2 ${
        checked ? "border-black" : "border-[#E0E0E0]"
      }`}
    >
      <div
        className={`w-4 h-4 rounded-[3px] border flex items-center justify-center flex-shrink-0 ${
          checked ? "bg-black border-black" : "border-[#E0E0E0] bg-white"
        }`}
        aria-hidden="true"
      >
        {checked && (
          <svg
            width="10"
            height="7"
            viewBox="0 0 10 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M9.53906 0.193359C9.73242 0.408203 9.73242 0.730469 9.53906 0.923828L3.86719 6.5957C3.65234 6.81055 3.33008 6.81055 3.13672 6.5957L0.214844 3.67383C0 3.48047 0 3.1582 0.214844 2.96484C0.408203 2.75 0.730469 2.75 0.923828 2.96484L3.48047 5.52148L8.80859 0.193359C9.00195 0 9.32422 0 9.51758 0.193359H9.53906Z" fill="white"/>
          </svg>
        )}
      </div>
      <span
        className="text-left text-base leading-[24px] text-black"
        style={{ fontFamily: "TT Commons Pro" }}
      >
        {label}
      </span>
    </button>
  );
}
